import React from 'react';
import classnames from 'classnames';
import moment from 'moment-timezone';
import Input from 'common/components/core/input';
import PlacesSearchBox from 'common/components/core/map/PlacesSearchBox';
import DateTimePicker from 'common/components/core/form/DateTimePicker';

import { Button, ButtonTypes } from 'common/components/core/button';

export class SingleBreak extends React.Component {
    onBreakValueChange = (data, ...args) => {
        const { onBreakValueChange, breakType, breakIndex } = this.props;
        // fieldId, breakType, index, value, lat, lng, description
        onBreakValueChange &&
            onBreakValueChange(
                {
                    ...data,
                    breakType,
                    breakIndex
                },
                ...args
            );
    };

    deleteBreak = () => {
        const { deleteBreak, breakType, breakKey, breakIndex } = this.props;
        deleteBreak && deleteBreak(breakType, breakKey, breakIndex);
    };

    onDurationChange = (value, fieldId, ...args) => {
        this.onBreakValueChange({ value, fieldId }, ...args);
    };

    onStartTimeChange = (value, ...args) => {
        const { currentDate } = this.props;
        this.onBreakValueChange(
            {
                value: value || moment(currentDate),
                fieldId: 'startTime'
            },
            ...args
        );
    };

    onEndTimeChange = (value, ...args) => {
        const { currentDate } = this.props;
        this.onBreakValueChange(
            {
                value: value || moment(currentDate),
                fieldId: 'endTime'
            },
            ...args
        );
    };

    onLocationChange = (lat, lng, description, ...args) => {
        this.onBreakValueChange(
            { lat, lng, description, fieldId: 'location' },
            ...args
        );
    };
    handleFocus = () => {
        const { handleFieldFocus, breakKey } = this.props;
        handleFieldFocus && handleFieldFocus(breakKey);
    };

    render() {
        const {
            isActive,
            isUnapplied,
            homebases,
            theme,
            t,
            transactionDuration,
            startLocationAddress,
            startTime,
            endTime,
            endShiftInstant,
            shiftStart,
            shiftEnd,
            breakShift
        } = this.props;
        // breakShift is not passed when adding break from plan screen.
        // breakShift is not a flow model in plan screen
        const breakEndError =
            breakShift
                ?.setAllValidationErrors()
                .getValidationMessage('endShiftInstant') ||
            breakShift?.validateBreakEndWithShift({
                shiftEnd,
                endShiftInstant
            });
        return (
            <div
                className={classnames(theme.breakWrap, {
                    [theme.activeBreak]: isActive,
                    [theme.unappliedBreak]: isUnapplied
                })}
            >
                <Input
                    type="number"
                    fieldId="duration"
                    autoFocus
                    theme={theme}
                    min="0"
                    pattern="\d*"
                    value={transactionDuration / 60}
                    onChange={this.onDurationChange}
                    rightIcon="min"
                    onFocus={this.handleFocus}
                />
                <DateTimePicker
                    showDate={false}
                    theme={theme}
                    fieldId="startTime"
                    label={t('breakBetween')}
                    value={startTime}
                    className={theme.startTime}
                    onChange={this.onStartTimeChange}
                    onFocus={this.handleFocus}
                    min={shiftStart}
                    max={shiftEnd}
                />
                <DateTimePicker
                    showDate={false}
                    fieldId="endTime"
                    className={theme.endTime}
                    value={endTime}
                    label={t('to')}
                    theme={theme}
                    onChange={this.onEndTimeChange}
                    onFocus={this.handleFocus}
                    min={shiftStart}
                    max={shiftEnd}
                    error={breakEndError}
                />
                <PlacesSearchBox
                    fieldId="startTime"
                    selectedAddress={startLocationAddress}
                    cachedSearchList={homebases}
                    theme={theme}
                    onPlacesChanged={this.onLocationChange}
                    label={t('at')}
                    placeholder={t('optionalAddress')}
                    disabled={false}
                    portal
                    useDefaultCenter
                />
                <Button
                    ripple={false}
                    buttonType={ButtonTypes.Icon}
                    icon="delete-bin"
                    onClick={this.deleteBreak}
                    theme={theme}
                    className={theme.deleteBtn}
                />
            </div>
        );
    }
}

export default SingleBreak;
